module.exports = "<div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/routes/bookings/booking/goldupgrade/goldupgrade.html
// module id = 136
// module chunks = 0